export const environment = {
  apiUrl: 'https://backend.app.easy-fitpass.com/api',
  appUrl: 'https://app.easy-fitpass.com',
  production: true,
  auth0Domain: 'easy-fitpass.eu.auth0.com',
  auth0ClientId: 'N6DB3v3RdNt2pOKaMdbct5VS0wYiOQ37',
  auth0Audience: 'https://backend.app.easy-fitpass.com/api',
  roleNamespace: 'https://app.easy-fitpass.com/roles',
  smartlookEnabled: true,
};
